export { default as EMOJI } from './lib/emoji';
export { default as VISITOR_INFO } from './lib/visitor-info';
export { default as PROVINCE } from './lib/province';
export { default as PLAN } from './lib/plan';
export { default as ENV_CONFIG } from './lib/env-config';
export { default as ENGINE_ICON_MAP } from './lib/engine-icon-map';
export { default as ATTRS_LABEL } from './lib/attrs-label';
export { default as OVERSEA_COUNTRY } from './lib/oversea-country';
export { default as SOURCE } from './lib/source';
export { default as VERSIONS } from './lib/versions';
export { default as INVITE_STATUS } from './lib/invite-status';
export { default as CALL_STUFFS } from './lib/call';
export { default as GENDER_OPTIONS } from './lib/gender-options';
export { default as LANGUAGE_CONFIGURE } from './lib/language-info';
export { default as PRIVATIZATION } from './lib/privatization';
export { default as ENTERPRISEINFO } from './lib/enterprise-info';

export const SOURCE_TYPE = {
  redbook: '小红书',
  douyin: '抖音',
  wx_video: '微信视频号'
};
